'use client';

import { useEffect } from 'react';

export const PreviewPage = ({
  url,
  fileName,
}: {
  url: string;
  fileName: string;
}) => {
  useEffect(() => {
    if (!url) {
      return;
    }
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [url, fileName]);
  return <div />;
};
